import { SelectAttributeProps } from 'Types/Attribute.types'
import Select from 'antd/lib/select'
import React, { useCallback } from 'react'
import './Select.less'

const SelectAttribute: React.FC<SelectAttributeProps> = props => {
    const handleChange = useCallback(
        (value: string) => {
            props.onChange(value.length ? value : undefined)
        },
        [props]
    )

    const filterOption = useCallback(
        (input: string, option?: { label: string; value: string }) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
        []
    )

    return (
        <div
            className={`attribute-main ${props.className}`}
            style={{ width: props.width ?? '90%' }}
            data-testid="select-wrapper"
        >
            <span className="attribute-main-title">{props.label}</span>
            <Select
                showSearch
                value={props.value}
                onChange={handleChange}
                filterOption={filterOption}
                options={props.options}
                mode={props.mode}
                allowClear={props.allowClear}
                placeholder={props.placeholder ?? 'Please select value'}
                disabled={props.readonly}
            />
        </div>
    )
}
export default SelectAttribute
